// Live-Vorschau des Ziel-Dateinamens einer Sprachprobe.
//
// Nutzt DIESELBE Funktion wie der Worker (shared/naming.js buildAudioFilename) —
// deshalb liegt sie seit 2026-09-11 in shared/ und nicht mehr unter worker/lib/.
// Eine nachgebaute Frontend-Fassung waere eine Divergenz-Falle: der Nutzer saehe
// einen Namen, den der Server so nie vergibt.
//
// Der Name haengt auch am SPRECHERNAMEN. Wird der im Formular geaendert, aendert
// sich der Zielname jeder Probe — genau das soll die Vorschau zeigen, bevor
// gespeichert wird.
import { buildAudioFilename } from '@shared/naming.js';
import type { VoiceAudio } from '@shared/types';

interface Args {
  audio: VoiceAudio;
  /** Vorgemerkte, noch ungeschriebene Aenderungen dieser Probe. */
  draft?: Partial<VoiceAudio>;
  /** Aktueller Stand der Namensfelder AUS DEM FORMULAR, nicht aus der DB. */
  lastName: string;
  firstName: string | null;
}

/**
 * Der Dateiname, den diese Probe nach dem Speichern tragen wird — oder null,
 * wenn er sich nicht bilden laesst. Letzteres ist kein Fehlerfall, sondern
 * Alltag: `languageNamePart` wirft bei einem Sprachcode ohne Datei-Marker, und
 * waehrend des Tippens ist der Nachname kurzzeitig leer. Die Vorschau
 * verschwindet dann still, statt eine Fehlermeldung zu erzeugen.
 */
export function audioFilenamePreview({ audio, draft, lastName, firstName }: Args): string | null {
  const eff = { ...audio, ...draft };
  if (!lastName.trim()) return null;
  try {
    return buildAudioFilename({
      lastName, firstName, voiceId: audio.voice_id,
      language: eff.language, dialect: eff.dialect, accent: eff.accent,
      category: eff.category, isDemomix: eff.is_demomix,
      sequence: eff.sequence, freetextSuffix: eff.freetext_suffix,
    });
  } catch {
    return null;
  }
}
